import React, { useEffect, useState, useMemo , useRef } from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  setShiftPermissionActions,
  SetTheShiftPermissionDelete,
  setTheoptions,
  setThecountBasedRenders,
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  ///--- for the state region zone fileter
  setthePermissionrequestState,
  setThePermissionRequestRegion,
  setThePermissionRequestZone,
  ///----date range
  setThePermssionrequestRange1,
  setThePermissionRequestRange2,
  setThePermissionStatusState,
  setTheEmployeeDesginationPermission,
  setTablePositionPersist
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import ShPermissionApprove from "./ShPermissionApprove";
import Delete from "../../AppComponent/Popup/Delete";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";

import { differenceInDays } from "date-fns";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";
import useDebouncedEffect from 'use-debounced-effect';
import dayjs from "dayjs";

const Permission = () => {
  const dispatch = useDispatch();
  const TablePositionPersist = useSelector(
    (state) => state.PreviousPagePosition.TablePositionPersist
  );
  const dateRangeRef = useRef(null);
  
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.PermissionRequestPage?.page == undefined
      ? 1
      : TablePositionPersist.PermissionRequestPage.page
  );

const [search, setsearch] = useState(
    TablePositionPersist?.PermissionRequestPage?.search == undefined || 
     TablePositionPersist?.PermissionRequestPage?.search ==""
      ? ""
      : TablePositionPersist.PermissionRequestPage.search
  );
 
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const state = useSelector((state) => state);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );

  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const [yearAndMonth, setYearMpnth] = useState();
  // const date = new Date();
  // console.log(date.getFullYear(), "date");
  // const months =
  //   date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth();
  // console.log(yearAndMonth, "yearAndMonth");
  // const displaydate =
  //   date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();

  // const YearList = date.getFullYear();
  // //var yearAndMonth = `${date.getFullYear()}-${months}`;
  // useEffect(() => {
  //   setYearMpnth(`${date.getFullYear()}-${months}`);
  // }, []);

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(state.StateManagementOverallCall.PermissionRequestRange1);
  var gt = convert(state.StateManagementOverallCall.PermissionRequestRange2);
           const today_day = dayjs().format("YYYY-MM-DD");
  
  const [range, setrange] = useState(
    state.StateManagementOverallCall.PermissionRequestRange1 == ""
        ? [today_day ,today_day] 

      : [it, gt]
  );

  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      dispatch(setThePermssionrequestRange1(range[0]));
      dispatch(setThePermissionRequestRange2(range[1]));
    }
            if(state.StateManagementOverallCall.PermissionRequestRange1 == ""){
              dispatch(setThePermssionrequestRange1(today_day));
              dispatch(setThePermissionRequestRange2(today_day));
            }
  }, [range]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  const [filterForWhite, setFilters] = useState({ white_collar: 
    state.StateManagementOverallCall.PermissionEmployeedesignation?.value == ""?
    "":
    state.StateManagementOverallCall.PermissionEmployeedesignation?.value == 1 ?
    true:
    false

   });
  const HandleEMprole = (e) => {
     
    if (e != null) {
       dispatch(setTheEmployeeDesginationPermission(e))
      setdtPageindex(1);

      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(setTheEmployeeDesginationPermission({value:"",label:"All"}))
      }
    }
  };

  const UserObjectData = useSelector((state) => state.users.UserData);

  const FileterState = {
    status: state.StateManagementOverallCall.PermissionStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  const options = [
    { value: "", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "decline", label: "Decline" },
    { value: "approved", label: "Approved" },
  ];
  const [place, SetPlace] = useState("All");
  const [sel, setSelected] = useState();
  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.PermissionrequestRegion
  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.PermissionrequestZone
  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({
    zone: state.StateManagementOverallCall.PermissionrequestZone?.value,
    state: state.StateManagementOverallCall.PermissionrequestState?.value,
    region: state.StateManagementOverallCall.PermissionrequestRegion?.value,
  });
  const [multiselect, setMuliselect] = useState([
    //  { value: "", label: "ALL" }
    state.StateManagementOverallCall.PermissionrequestState,
    // state.ClientBranchIDs.StateName,
  ]);

 
  ///--shift----permission----
  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
  // if (
  //       state.shiftPermission.shiftPermissiondata.length == 0 ||
  //       TablePositionPersist?.PermissionRequestPage?.page != dtpageindex ||
  //       TablePositionPersist?.PermissionRequestPage?.search != search ||
  //       TablePositionPersist?.PermissionRequestPage?.selectVal?.status != selectVal.status ||
  //       TablePositionPersist?.PermissionRequestPage?.from_date != range[0] ||
  //       TablePositionPersist?.PermissionRequestPage?.to_date != range[1] ||
  //       TablePositionPersist?.PermissionRequestPage?.white_collar !== filterForWhite.white_collar ||
  //       TablePositionPersist?.PermissionRequestPage?.data?.state != data.state ||
  //       TablePositionPersist?.PermissionRequestPage?.data?.region != data.region ||
  //       TablePositionPersist?.PermissionRequestPage?.data?.zone != data.zone ||

  //         TablePositionPersist?.PermissionRequestPage?.isApproved 
  //     ) {
      const payloads = {
        search: search,
        page_size: 20,
        page: dtpageindex,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
        // month: Datestate.month,
        // year: Datestate.year,
        from_date: range[0],

        to_date: range[1],
      };
      dispatch(setShiftPermissionActions(payloads));

      dispatch(
        setTablePositionPersist({
          data: payloads,
          pageName: "PermissionRequestScrollView",
        })
      );

    }
    // }
     currentRef.current.scrollTop = sessionStorage.getItem(
      "approverequestempTableScrollPosition"
    );


  }, [selectVal, data, filterForWhite, range, dtpageindex , search]);
console.log(TablePositionPersist?.PermissionRequestPage ,"TablePositionPersist?.PermissionRequestPage");

  ///----Filter-----------------------

  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);

  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  useEffect(() => {
    const Datas = [];

    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.state_name.toUpperCase(),
        });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.region_name.toUpperCase(),
        });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setMuliselect3({ value: "search", label: "Search" });

      setData({
        ...data,
        region: selectedVal.value,
      });
      dispatch(setThePermissionRequestRegion(selectedVal));
      dispatch(setThePermissionRequestZone({ value: "", label: "ALL" }));
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setThePermissionRequestRegion({ value: "", label: "ALL" }));
      dispatch(setThePermissionRequestZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
      dispatch(setThePermissionRequestZone(selectedVal));
    }
    if (selectedVal == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setThePermissionRequestZone({ value: "", label: "ALL" }));
    }
  };
  const handleSelectChange = (selectedVal) => {
    setdtPageindex(1);

    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setthePermissionrequestState(selectedVal));
      dispatch(setThePermissionRequestRegion({ value: "", label: "ALL" }));
      dispatch(setThePermissionRequestZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setthePermissionrequestState({ value: "", label: "ALL" }));
      dispatch(setThePermissionRequestRegion({ value: "", label: "ALL" }));
      dispatch(setThePermissionRequestZone({ value: "", label: "ALL" }));

      setData({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({
          value: element.id,
          label: element.zone_name.toUpperCase(),
        });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

 
   ///-----State----Input Changes
   const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,

    });

};

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
              regionSearch: SearchDebounance.regionSearch,
              zoneSearch: SearchDebounance.zoneSearch,
          });

      }
  },
  500,
  [SearchDebounance]
);
  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);

      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    // setsearch(e);
    setdtPageindex(1)
    debouncedSearch(e);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  
  const handleNext = (next) => {
    console.log(next ,"woiquenext");
    
        setdtPageindex(next + 1);
    
  };

   const GotoEnteredPage =(gotopage)=>{
     setdtPageindex(gotopage)
   }

   const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
   
    }
  };


  const handlePageChange = (newPage) => {
    if (newPage < state.shiftPermission.Total_Count) {
      setCurrentPage(newpages + 1);

      setNewpage(newPage + 1);
      const pageEntries = {
        search: search,
        page_size: 20,
        page: newPage,
        selectVal: selectVal,
        data: data,
        white_collar: filterForWhite.white_collar,
        // month: Datestate.month,
        // year: Datestate.year,

        from_date: range[0],

        to_date: range[1],
      };
      dispatch(setShiftPermissionActions(pageEntries));
    }
  };
  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = [
//       {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
    {
      Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name != undefined ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>----</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Email",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.email}</span>
          </>
        );
      },
    },
    {
      Header: "From Date",
      accessor: "for_date",
      Cell: (row) => {
        return (
          <>
            {row.row.original.for_date != null ? (
              <span>{row.row.original.for_date}</span>
            ) : (
              <span>{"---"}</span>
            )}
          </>
        );
      },
    },
    {
      Header: "From Time",
      accessor: "from_time",
    },
    {
      Header: "To Time",
      accessor: "to_time",
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;
        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              {row.row.original.status.toLowerCase() === "approved" ? (
                <button
                  className=" btn Status"
                  component="span"
                  style={{ cursor: "not-allowed" }}
                >
                  <span className="OuterActionSpan">
                  <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                    <span className="ActionsList"> Approved </span>
                  </span>
                </button>
              ) : (
                <>
                  {row.row.original.status.toLowerCase() === "decline" ? (
                    <button
                      className=" btn Status"
                      component="span"
                      style={{ cursor: "not-allowed" }}
                      
                    >
                      <span className="OuterActionSpan">
                      <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                        <span className="ActionsList"> Decline </span>
                      </span>
                    </button>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() === "pending" ? (
                        <button
                          className=" btn Status"
                          component="span"
                          onClick={(e) => {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }}
                        >
                          <span className="OuterActionSpan">
                          <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                            <span className="ActionsList"> Pending </span>
                          </span>
                        </button>
                      ) : null}
                    </>
                  )}
                </>
              )}
            </div>
          </>
        );
      },
    },
  ];
  const HandleSubmits = () => {
    const payload = {
      DeleteID: DeleteID,
      currentPage: currentPage,
      data: data,
      selectVal: selectVal,
      white_collar: filterForWhite.white_collar,
      // month: Datestate.month,
      // year: Datestate.year,
      from_date: range[0],

      to_date: range[1],
    };
    dispatch(SetTheShiftPermissionDelete(payload, setDeletePopup(false)));
  };

  const ClearState = (Counts) => {
    ///dispatch(setTheoptions({ value: "1", label: "ALL" }));
    if (Counts == 2) {
      dispatch(setThePermissionStatusState({ value: "", label: "All"}))

      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    console.log(SelectedValues , "SelectedValues");
    

    setdtPageindex(1);

    setSelected(sel);
    SetStates(true);
    // dispatch(setTheoptions(SelectedValues));
    // dispatch(setThecountBasedRenders(2));
     dispatch(setThePermissionStatusState(SelectedValues))

    if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
 
  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

const openMe = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('left', '631.344px', 'important');
    rsAnimFade.style.setProperty('top', '184.109px', 'important');   
  }
 }

 const CloseDateRange = ()=>{
  const rsAnimFade = document.querySelector('.rs-anim-fade');
  if (rsAnimFade) {
    rsAnimFade.style.setProperty('display', 'none', 'important');
    // rsAnimFade.style.setProperty('top', '184.109px', 'important');   
  }
 }
 const currentRef = useRef();
 const scrollPosition = (e) => {
   const val = currentRef.current.scrollTop; 
   sessionStorage.setItem("PermissionRequestScrollView", val);
 };

 const getZoomFactor = () => {
  const zoom = document.body.style.zoom;
  return zoom ? parseFloat(zoom) / 100 : 1;
};

const alignDateRangePicker = (pickerNode) => {
  const picker =
    pickerNode?.root || pickerNode?.container || pickerNode;

  const popup = document.querySelector(
    ".rs-picker-popup.rs-picker-popup-daterange"
  );

  if (!picker || !popup) return;

  const zoom = getZoomFactor();
  const rect = picker.getBoundingClientRect();

  const popupWidth = popup.offsetWidth;
  const popupHeight = popup.offsetHeight;

  const viewportWidth = window.innerWidth / zoom;
  const viewportHeight = window.innerHeight / zoom;

  const scrollX = window.scrollX / zoom;
  const scrollY = window.scrollY / zoom;

  let left = rect.right / zoom - popupWidth + scrollX;
  let top = rect.bottom / zoom + 8 + scrollY;

  if (left < 8) left = 8;
  if (left + popupWidth > viewportWidth - 8) {
    left = viewportWidth - popupWidth - 8;
  }

  if (top + popupHeight > viewportHeight + scrollY - 8) {
    top = rect.top / zoom - popupHeight - 8 + scrollY;
  }

  popup.style.position = "absolute";
  popup.style.left = `${left}px`;
  popup.style.top = `${top}px`;
};

  return (
    <>
      <div 
                    onScroll={scrollPosition}
              ref={currentRef}


      className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3> Permission Request</h3>

          </div>
        </div>
        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            marginLeft: "0px",
            marginRight: "0px",
            marginTop:"-27px "
          }}
        >
          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect}
              labelledBy="Select"
              // placeholder={"Search"}
            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
         isClearable={
  multiselect1
    ? Array.isArray(multiselect1)
      ? multiselect1.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect1.label === "ALL" || multiselect1.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}

            />
          </div>

          <div className="col-sm-2">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              value={multiselect3}
              options={nameList4}
                isClearable={
  multiselect3
    ? Array.isArray(multiselect3)
      ? multiselect3.some(
          (item) => item.label === "ALL" || item.label === "All"
        )
        ? false
        : true
      : multiselect3.label === "ALL" || multiselect3.label === "All"
      ? false
      : true
    : true
}              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
              // placeholder={
              //   data.state == ""
              //     ? "without selected state you can't select Zone"
              //     : data.region == ""
              //     ? "without selected Region you can't select Zone"
              //     : "Search"
              // }
            />
          </div>

          <div
            className="col-sm-2"
            style={{
              marginLeft: "-10px",
              display: "flex",

              flexDirection: "column",
              marginTop: "11px",
            }}
          >
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginTop: "-13px", position: "absolute" }}
            >
              {/* State Name */}
              Select Date
              <span style={{ color: "red" }}>*</span>
            </label>

            <div className="datepicker_dash" style={{ marginTop: "18px" }}>
              <DateRangePicker
                // defaultValue={[
                //   new Date(new Date().setDate(today.getDate() - 30)),
                //   new Date(),
                // ]}

                defaultValue={
                  state.StateManagementOverallCall.PermissionRequestRange1 == ""
                    ? [new Date(range[0]), new Date(range[1])]
                    : [
                        new Date(
                          state.StateManagementOverallCall.PermissionRequestRange1
                        ),
                        new Date(
                          state.StateManagementOverallCall.PermissionRequestRange2
                        ),
                      ]
                }
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                                ref={dateRangeRef}

                   onOpen={() => {
            
    setTimeout(() => {
      alignDateRangePicker(dateRangeRef.current);
    }, 80);
  }}


  style={{
    width: "100%",
    padding: "0px 5px",
  }}

                ranges={predefinedBottomRanges}
                placeholder="From - To"
                // style={{ width: 270, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  // if (e != null) {
                  //   setrange([]);

                  //   e.forEach((newValue) => {
                  //     var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                  //     var localISOTime = new Date(newValue - tzoffset)
                  //       .toISOString()
                  //       .slice(0, -1);
                  //     handlechangedate(localISOTime);
                  //   });
                  // }

                  if (e != null && e.length === 2) {
                    const [startDate, endDate] = e;
                    const diffDays = differenceInDays(endDate, startDate);
                    // if (diffDays === 30) {
                    //   // Since we are using inclusive range, difference should be 30 for 31 days
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else if (diffDays < 30) {
                    //   setrange([]);
                    //   e.forEach((newValue) => {
                    //     const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                    //     const localISOTime = new Date(newValue - tzoffset)
                    //       .toISOString()
                    //       .slice(0, -1);
                    //     handlechangedate(localISOTime);
                    //   });
                    // } else {
                    //   toast.error("Please select a range of exactly 31 days.", {
                    //     position: toast.POSITION.TOP_RIGHT,
                    //   });
                    // }


                    setrange([]);
                    e.forEach((newValue) => {
                      const tzoffset = new Date().getTimezoneOffset() * 60000; // offset in milliseconds
                      const localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      handlechangedate(localISOTime);
                    });
                    
                  }
                }}
              />
            </div>
          </div>
        </div>
<br/>
        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
              top: "95px",
            width:"92%",
              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div style={{width:"314px"}} ></div>
            <div
              class=" field-div"
              style={{
                position: "relative",
                top: "-11px",
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                zIndex: "1",
                 width:"351px"

              }}
            >
              <label
                for="validationCustom02"
                class="form-label"
                style={{ fontSize: "15px" }}
              >
                Employee Role
              </label>

              <Select
                className="Selects"
                styles={{ position: "relative", top: "60px" }}
                onChange={(e) => {
                  HandleEMprole(e);
                }}
                value={EMpROleSelected}
                options={EmpRoles}
                placeholder="search"
              />
            </div>
          </div> */}

          <ReactTable
            data={state.shiftPermission.shiftPermissiondata}
            columns={columns}
            totalItems={state.shiftPermission.Total_Count}
            currentPage={currentPage}
            // onPageChange={handlePageChange}

            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.shiftPermission.Total_Count}
            // onPageChange={handlePageChange}
            // onPageSizeChange={handlePageSizeChange}
            // onFirstPage={handleFirstPage}
            // OnhandleLastpgae={HandleLastPage}
            // Oncreate={(e) => setRoleCreatePopup(true)}
            values={state.StateManagementOverallCall.PermissionStatusState}
            options={options}
            Filter={Filter}
            count={count}
            ClearState={ClearState}
            placeHold={place}
            ApproveRequestFilter={true}

            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={state.StateManagementOverallCall.PermissionEmployeedesignation}
            HandleEMprole={HandleEMprole}
                                  searchVal={TablePositionPersist?.PermissionRequestPage?.search == "" || TablePositionPersist?.PermissionRequestPage?.search ==undefined? "":TablePositionPersist.PermissionRequestPage.search}
              search_key={true}


          />
        </div>
      </div>

      {EmployeePop && EmployeeIDs != undefined ? (
        <ShPermissionApprove
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          data={data}
          selectVal={selectVal}
          white_collar={filterForWhite.white_collar}
          // Datestate={Datestate}
          from_date={range[0]}
          search={search}
          to_date={range[1]}
        />
      ) : null}
      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete"}

          
        />
      ) : null}
    </>
  );
};

export default Permission;
